import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './auth-guard.service';
import {CustomAuthService} from './auth.service';
import {LoginComponent} from './login.component';
import {AlertService} from './alert.service';

const loginRoutes: Routes = [
  { path: 'login', component: LoginComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(loginRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthGuard,
    CustomAuthService,
      AlertService
  ]
})
export class LoginRoutingModule {}
